import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Recommendation = /*#__PURE__*/function (Recommendation) {
  Recommendation[Recommendation["RECOMMENDATION_UNSPECIFIED"] = 0] = "RECOMMENDATION_UNSPECIFIED";
  Recommendation[Recommendation["RECOMMENDATION_POSITIVE"] = 1] = "RECOMMENDATION_POSITIVE";
  Recommendation[Recommendation["RECOMMENDATION_NEGATIVE"] = 2] = "RECOMMENDATION_NEGATIVE";
  return Recommendation;
}(Recommendation || {});
var ReviewActionStatus = /*#__PURE__*/function (ReviewActionStatus) {
  ReviewActionStatus[ReviewActionStatus["REVIEW_ACTION_STATUS_ACTION_REQUIRED"] = 0] = "REVIEW_ACTION_STATUS_ACTION_REQUIRED";
  ReviewActionStatus[ReviewActionStatus["REVIEW_ACTION_STATUS_NO_ACTION_REQUIRED"] = 1] = "REVIEW_ACTION_STATUS_NO_ACTION_REQUIRED";
  ReviewActionStatus[ReviewActionStatus["REVIEW_ACTION_STATUS_OWNER_RESPONDED"] = 2] = "REVIEW_ACTION_STATUS_OWNER_RESPONDED";
  ReviewActionStatus[ReviewActionStatus["REVIEW_ACTION_STATUS_RESPONSE_AWAITING_APPROVAL"] = 3] = "REVIEW_ACTION_STATUS_RESPONSE_AWAITING_APPROVAL";
  ReviewActionStatus[ReviewActionStatus["REVIEW_ACTION_STATUS_DIGITAL_AGENT_RESPONDED"] = 4] = "REVIEW_ACTION_STATUS_DIGITAL_AGENT_RESPONDED";
  return ReviewActionStatus;
}(ReviewActionStatus || {});
var ReviewDeletedStatus = /*#__PURE__*/function (ReviewDeletedStatus) {
  ReviewDeletedStatus[ReviewDeletedStatus["REVIEW_DELETED_STATUS_EMPTY"] = 0] = "REVIEW_DELETED_STATUS_EMPTY";
  ReviewDeletedStatus[ReviewDeletedStatus["REVIEW_DELETED_STATUS_USER_REMOVED"] = 1] = "REVIEW_DELETED_STATUS_USER_REMOVED";
  ReviewDeletedStatus[ReviewDeletedStatus["REVIEW_DELETED_STATUS_USER_KEPT"] = 2] = "REVIEW_DELETED_STATUS_USER_KEPT";
  ReviewDeletedStatus[ReviewDeletedStatus["REVIEW_DELETED_STATUS_UNSPECIFIED"] = 3] = "REVIEW_DELETED_STATUS_UNSPECIFIED";
  return ReviewDeletedStatus;
}(ReviewDeletedStatus || {});
var ThirdPartyPublishedStatus = /*#__PURE__*/function (ThirdPartyPublishedStatus) {
  ThirdPartyPublishedStatus[ThirdPartyPublishedStatus["THIRD_PARTY_PUBLISHED_STATUS_EMPTY"] = 0] = "THIRD_PARTY_PUBLISHED_STATUS_EMPTY";
  ThirdPartyPublishedStatus[ThirdPartyPublishedStatus["THIRD_PARTY_PUBLISHED_STATUS_TRUE"] = 1] = "THIRD_PARTY_PUBLISHED_STATUS_TRUE";
  ThirdPartyPublishedStatus[ThirdPartyPublishedStatus["THIRD_PARTY_PUBLISHED_STATUS_FALSE"] = 2] = "THIRD_PARTY_PUBLISHED_STATUS_FALSE";
  return ThirdPartyPublishedStatus;
}(ThirdPartyPublishedStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SMSState = /*#__PURE__*/function (SMSState) {
  SMSState[SMSState["SMS_STATE_UNDEFINED"] = 0] = "SMS_STATE_UNDEFINED";
  SMSState[SMSState["SMS_STATE_DISABLED"] = 1] = "SMS_STATE_DISABLED";
  SMSState[SMSState["SMS_STATE_ENABLED"] = 2] = "SMS_STATE_ENABLED";
  return SMSState;
}(SMSState || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ListWidgetReviewsRequestMinimumRating = /*#__PURE__*/function (ListWidgetReviewsRequestMinimumRating) {
  ListWidgetReviewsRequestMinimumRating[ListWidgetReviewsRequestMinimumRating["MINIMUM_RATING_UNSPECIFIED"] = 0] = "MINIMUM_RATING_UNSPECIFIED";
  ListWidgetReviewsRequestMinimumRating[ListWidgetReviewsRequestMinimumRating["MINIMUM_RATING_1"] = 1] = "MINIMUM_RATING_1";
  ListWidgetReviewsRequestMinimumRating[ListWidgetReviewsRequestMinimumRating["MINIMUM_RATING_2"] = 2] = "MINIMUM_RATING_2";
  ListWidgetReviewsRequestMinimumRating[ListWidgetReviewsRequestMinimumRating["MINIMUM_RATING_3"] = 3] = "MINIMUM_RATING_3";
  ListWidgetReviewsRequestMinimumRating[ListWidgetReviewsRequestMinimumRating["MINIMUM_RATING_4"] = 4] = "MINIMUM_RATING_4";
  ListWidgetReviewsRequestMinimumRating[ListWidgetReviewsRequestMinimumRating["MINIMUM_RATING_5"] = 5] = "MINIMUM_RATING_5";
  ListWidgetReviewsRequestMinimumRating[ListWidgetReviewsRequestMinimumRating["MINIMUM_RATING_MANUALLY_PUBLISHED"] = 6] = "MINIMUM_RATING_MANUALLY_PUBLISHED";
  return ListWidgetReviewsRequestMinimumRating;
}(ListWidgetReviewsRequestMinimumRating || {});
var CustomizationsOverallRatingDecimalPlaces = /*#__PURE__*/function (CustomizationsOverallRatingDecimalPlaces) {
  CustomizationsOverallRatingDecimalPlaces[CustomizationsOverallRatingDecimalPlaces["OVERALL_RATING_DECIMAL_PLACES_NOT_SET"] = 0] = "OVERALL_RATING_DECIMAL_PLACES_NOT_SET";
  CustomizationsOverallRatingDecimalPlaces[CustomizationsOverallRatingDecimalPlaces["OVERALL_RATING_DECIMAL_PLACES_1"] = 1] = "OVERALL_RATING_DECIMAL_PLACES_1";
  CustomizationsOverallRatingDecimalPlaces[CustomizationsOverallRatingDecimalPlaces["OVERALL_RATING_DECIMAL_PLACES_2"] = 2] = "OVERALL_RATING_DECIMAL_PLACES_2";
  return CustomizationsOverallRatingDecimalPlaces;
}(CustomizationsOverallRatingDecimalPlaces || {});
var StylingTheme = /*#__PURE__*/function (StylingTheme) {
  StylingTheme[StylingTheme["THEME_UNSPECIFIED"] = 0] = "THEME_UNSPECIFIED";
  StylingTheme[StylingTheme["THEME_LIGHT"] = 1] = "THEME_LIGHT";
  StylingTheme[StylingTheme["THEME_DARK"] = 2] = "THEME_DARK";
  return StylingTheme;
}(StylingTheme || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var LimitType = /*#__PURE__*/function (LimitType) {
  LimitType[LimitType["LIMIT_TYPE_UNSPECIFIED"] = 0] = "LIMIT_TYPE_UNSPECIFIED";
  LimitType[LimitType["LIMIT_TYPE_MONTHLY_SMS"] = 1] = "LIMIT_TYPE_MONTHLY_SMS";
  return LimitType;
}(LimitType || {});
var ListingMatchQuality = /*#__PURE__*/function (ListingMatchQuality) {
  ListingMatchQuality[ListingMatchQuality["LISTING_MATCH_QUALITY_GOOD"] = 0] = "LISTING_MATCH_QUALITY_GOOD";
  ListingMatchQuality[ListingMatchQuality["LISTING_MATCH_QUALITY_POOR"] = 1] = "LISTING_MATCH_QUALITY_POOR";
  ListingMatchQuality[ListingMatchQuality["LISTING_MATCH_QUALITY_NO_MATCH"] = 2] = "LISTING_MATCH_QUALITY_NO_MATCH";
  return ListingMatchQuality;
}(ListingMatchQuality || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_NOT_SET"] = 0] = "SORT_DIRECTION_NOT_SET";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var ListReviewRequestEmailTemplatesRequestSortField = /*#__PURE__*/function (ListReviewRequestEmailTemplatesRequestSortField) {
  ListReviewRequestEmailTemplatesRequestSortField[ListReviewRequestEmailTemplatesRequestSortField["SORT_FIELD_NOT_SET"] = 0] = "SORT_FIELD_NOT_SET";
  ListReviewRequestEmailTemplatesRequestSortField[ListReviewRequestEmailTemplatesRequestSortField["SORT_FIELD_UPDATED"] = 1] = "SORT_FIELD_UPDATED";
  ListReviewRequestEmailTemplatesRequestSortField[ListReviewRequestEmailTemplatesRequestSortField["SORT_FIELD_NAME"] = 2] = "SORT_FIELD_NAME";
  return ListReviewRequestEmailTemplatesRequestSortField;
}(ListReviewRequestEmailTemplatesRequestSortField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Review {
  static fromProto(proto) {
    let m = new Review();
    m = Object.assign(m, proto);
    if (proto.reviewId) {
      m.reviewId = ReviewIdentifier.fromProto(proto.reviewId);
    }
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.scaledStars) {
      m.scaledStars = parseInt(proto.scaledStars, 10);
    }
    if (proto.reviewer) {
      m.reviewer = Reviewer.fromProto(proto.reviewer);
    }
    if (proto.published) {
      m.published = new Date(proto.published);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.actionStatus) {
      m.actionStatus = enumStringToValue$7(ReviewActionStatus, proto.actionStatus);
    }
    if (proto.comments) {
      m.comments = proto.comments.map(ReviewComment.fromProto);
    }
    if (proto.recommendation) {
      m.recommendation = enumStringToValue$7(Recommendation, proto.recommendation);
    }
    if (proto.lastFailedReviewCommentCreated) {
      m.lastFailedReviewCommentCreated = new Date(proto.lastFailedReviewCommentCreated);
    }
    if (proto.edited) {
      m.edited = new Date(proto.edited);
    }
    if (proto.deletedStatus) {
      m.deletedStatus = enumStringToValue$7(ReviewDeletedStatus, proto.deletedStatus);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.thirdPartyPublishedStatus) {
      m.thirdPartyPublishedStatus = enumStringToValue$7(ThirdPartyPublishedStatus, proto.thirdPartyPublishedStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined' && this.reviewId !== null) {
      toReturn['reviewId'] = 'toApiJson' in this.reviewId ? this.reviewId.toApiJson() : this.reviewId;
    }
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.rating !== 'undefined') {
      toReturn['rating'] = this.rating;
    }
    if (typeof this.scaledStars !== 'undefined') {
      toReturn['scaledStars'] = this.scaledStars;
    }
    if (typeof this.originalStars !== 'undefined') {
      toReturn['originalStars'] = this.originalStars;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.reviewer !== 'undefined' && this.reviewer !== null) {
      toReturn['reviewer'] = 'toApiJson' in this.reviewer ? this.reviewer.toApiJson() : this.reviewer;
    }
    if (typeof this.published !== 'undefined' && this.published !== null) {
      toReturn['published'] = 'toApiJson' in this.published ? this.published.toApiJson() : this.published;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.actionStatus !== 'undefined') {
      toReturn['actionStatus'] = this.actionStatus;
    }
    if (typeof this.isPublished !== 'undefined') {
      toReturn['isPublished'] = this.isPublished;
    }
    if (typeof this.isSharedByReviewer !== 'undefined') {
      toReturn['isSharedByReviewer'] = this.isSharedByReviewer;
    }
    if (typeof this.newComment !== 'undefined') {
      toReturn['newComment'] = this.newComment;
    }
    if (typeof this.comments !== 'undefined' && this.comments !== null) {
      toReturn['comments'] = 'toApiJson' in this.comments ? this.comments.toApiJson() : this.comments;
    }
    if (typeof this.hasAccuratePublished !== 'undefined') {
      toReturn['hasAccuratePublished'] = this.hasAccuratePublished;
    }
    if (typeof this.recommendation !== 'undefined') {
      toReturn['recommendation'] = this.recommendation;
    }
    if (typeof this.lastFailedReviewCommentCreated !== 'undefined' && this.lastFailedReviewCommentCreated !== null) {
      toReturn['lastFailedReviewCommentCreated'] = 'toApiJson' in this.lastFailedReviewCommentCreated ? this.lastFailedReviewCommentCreated.toApiJson() : this.lastFailedReviewCommentCreated;
    }
    if (typeof this.lastFailedReviewCommentReason !== 'undefined') {
      toReturn['lastFailedReviewCommentReason'] = this.lastFailedReviewCommentReason;
    }
    if (typeof this.lastFailedReviewCommentText !== 'undefined') {
      toReturn['lastFailedReviewCommentText'] = this.lastFailedReviewCommentText;
    }
    if (typeof this.edited !== 'undefined' && this.edited !== null) {
      toReturn['edited'] = 'toApiJson' in this.edited ? this.edited.toApiJson() : this.edited;
    }
    if (typeof this.deletedStatus !== 'undefined') {
      toReturn['deletedStatus'] = this.deletedStatus;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.thirdPartyPublishedStatus !== 'undefined') {
      toReturn['thirdPartyPublishedStatus'] = this.thirdPartyPublishedStatus;
    }
    return toReturn;
  }
}
class ReviewComment {
  static fromProto(proto) {
    let m = new ReviewComment();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.published) {
      m.published = new Date(proto.published);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commentId !== 'undefined') {
      toReturn['commentId'] = this.commentId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.published !== 'undefined' && this.published !== null) {
      toReturn['published'] = 'toApiJson' in this.published ? this.published.toApiJson() : this.published;
    }
    if (typeof this.postedByOwner !== 'undefined') {
      toReturn['postedByOwner'] = this.postedByOwner;
    }
    if (typeof this.postedByDigitAgent !== 'undefined') {
      toReturn['postedByDigitAgent'] = this.postedByDigitAgent;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    return toReturn;
  }
}
class ReviewHistory {
  static fromProto(proto) {
    let m = new ReviewHistory();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = parseInt(proto.source, 10);
    }
    if (proto.scaledStarRating) {
      m.scaledStarRating = parseInt(proto.scaledStarRating, 10);
    }
    if (proto.published) {
      m.published = new Date(proto.published);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.reviewLastEdited) {
      m.reviewLastEdited = new Date(proto.reviewLastEdited);
    }
    if (proto.isRecommendation) {
      m.isRecommendation = enumStringToValue$7(Recommendation, proto.isRecommendation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewHistoryId !== 'undefined') {
      toReturn['reviewHistoryId'] = this.reviewHistoryId;
    }
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.scaledStarRating !== 'undefined') {
      toReturn['scaledStarRating'] = this.scaledStarRating;
    }
    if (typeof this.reviewerName !== 'undefined') {
      toReturn['reviewerName'] = this.reviewerName;
    }
    if (typeof this.published !== 'undefined' && this.published !== null) {
      toReturn['published'] = 'toApiJson' in this.published ? this.published.toApiJson() : this.published;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.reviewLastEdited !== 'undefined' && this.reviewLastEdited !== null) {
      toReturn['reviewLastEdited'] = 'toApiJson' in this.reviewLastEdited ? this.reviewLastEdited.toApiJson() : this.reviewLastEdited;
    }
    if (typeof this.isRecommendation !== 'undefined') {
      toReturn['isRecommendation'] = this.isRecommendation;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class ReviewIdentifier {
  static fromProto(proto) {
    let m = new ReviewIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    return toReturn;
  }
}
class Reviewer {
  static fromProto(proto) {
    let m = new Reviewer();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class ThirdPartyReviewPublishSettings {
  static fromProto(proto) {
    let m = new ThirdPartyReviewPublishSettings();
    m = Object.assign(m, proto);
    if (proto.minimumPublishRating) {
      m.minimumPublishRating = parseInt(proto.minimumPublishRating, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetAllReviewsEnabled !== 'undefined') {
      toReturn['widgetAllReviewsEnabled'] = this.widgetAllReviewsEnabled;
    }
    if (typeof this.minimumPublishRating !== 'undefined') {
      toReturn['minimumPublishRating'] = this.minimumPublishRating;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetLeaveReviewURLsRequest {
  static fromProto(proto) {
    let m = new GetLeaveReviewURLsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    return toReturn;
  }
}
class GetLeaveReviewURLsResponse {
  static fromProto(proto) {
    let m = new GetLeaveReviewURLsResponse();
    m = Object.assign(m, proto);
    if (proto.urls) {
      m.urls = Object.keys(proto.urls).reduce((obj, k) => {
        obj[k] = proto.urls[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.urls !== 'undefined' && this.urls !== null) {
      toReturn['urls'] = 'toApiJson' in this.urls ? this.urls.toApiJson() : this.urls;
    }
    return toReturn;
  }
}
class ReviewRequestTemplate {
  static fromProto(proto) {
    let m = new ReviewRequestTemplate();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.externalTemplateId !== 'undefined') {
      toReturn['externalTemplateId'] = this.externalTemplateId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.isDefault !== 'undefined') {
      toReturn['isDefault'] = this.isDefault;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class GetLeaveReviewURLsResponseUrlsEntry {
  static fromProto(proto) {
    let m = new GetLeaveReviewURLsResponseUrlsEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ConciergeReviewResponse {
  static fromProto(proto) {
    let m = new ConciergeReviewResponse();
    m = Object.assign(m, proto);
    if (proto.feedbackDate) {
      m.feedbackDate = new Date(proto.feedbackDate);
    }
    if (proto.approvalRequestedDate) {
      m.approvalRequestedDate = new Date(proto.approvalRequestedDate);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.response !== 'undefined') {
      toReturn['response'] = this.response;
    }
    if (typeof this.agentName !== 'undefined') {
      toReturn['agentName'] = this.agentName;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.replyToEmail !== 'undefined') {
      toReturn['replyToEmail'] = this.replyToEmail;
    }
    if (typeof this.feedback !== 'undefined') {
      toReturn['feedback'] = this.feedback;
    }
    if (typeof this.feedbackProvider !== 'undefined') {
      toReturn['feedbackProvider'] = this.feedbackProvider;
    }
    if (typeof this.commentId !== 'undefined') {
      toReturn['commentId'] = this.commentId;
    }
    if (typeof this.feedbackDate !== 'undefined' && this.feedbackDate !== null) {
      toReturn['feedbackDate'] = 'toApiJson' in this.feedbackDate ? this.feedbackDate.toApiJson() : this.feedbackDate;
    }
    if (typeof this.approvalRequestedDate !== 'undefined' && this.approvalRequestedDate !== null) {
      toReturn['approvalRequestedDate'] = 'toApiJson' in this.approvalRequestedDate ? this.approvalRequestedDate.toApiJson() : this.approvalRequestedDate;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    if (typeof this.faviconUrl !== 'undefined') {
      toReturn['faviconUrl'] = this.faviconUrl;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetSMSEnabledRequest {
  static fromProto(proto) {
    let m = new GetSMSEnabledRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetSMSEnabledResponse {
  static fromProto(proto) {
    let m = new GetSMSEnabledResponse();
    m = Object.assign(m, proto);
    if (proto.smsState) {
      m.smsState = enumStringToValue$4(SMSState, proto.smsState);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.smsState !== 'undefined') {
      toReturn['smsState'] = this.smsState;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateReviewRequest {
  static fromProto(proto) {
    let m = new CreateReviewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.starRating !== 'undefined') {
      toReturn['starRating'] = this.starRating;
    }
    if (typeof this.reviewerName !== 'undefined') {
      toReturn['reviewerName'] = this.reviewerName;
    }
    if (typeof this.reviewerEmail !== 'undefined') {
      toReturn['reviewerEmail'] = this.reviewerEmail;
    }
    if (typeof this.reviewTitle !== 'undefined') {
      toReturn['reviewTitle'] = this.reviewTitle;
    }
    if (typeof this.reviewContent !== 'undefined') {
      toReturn['reviewContent'] = this.reviewContent;
    }
    return toReturn;
  }
}
class CreateReviewResponse {
  static fromProto(proto) {
    let m = new CreateReviewResponse();
    m = Object.assign(m, proto);
    if (proto.review) {
      m.review = Review.fromProto(proto.review);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.review !== 'undefined' && this.review !== null) {
      toReturn['review'] = 'toApiJson' in this.review ? this.review.toApiJson() : this.review;
    }
    return toReturn;
  }
}
class CreateReviewWidgetRequest {
  static fromProto(proto) {
    let m = new CreateReviewWidgetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class CreateReviewWidgetResponse {
  static fromProto(proto) {
    let m = new CreateReviewWidgetResponse();
    m = Object.assign(m, proto);
    if (proto.reviewWidget) {
      m.reviewWidget = ReviewWidget.fromProto(proto.reviewWidget);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewWidget !== 'undefined' && this.reviewWidget !== null) {
      toReturn['reviewWidget'] = 'toApiJson' in this.reviewWidget ? this.reviewWidget.toApiJson() : this.reviewWidget;
    }
    return toReturn;
  }
}
class Customizations {
  static fromProto(proto) {
    let m = new Customizations();
    m = Object.assign(m, proto);
    if (proto.overallRatingDecimalPlaces) {
      m.overallRatingDecimalPlaces = enumStringToValue$3(CustomizationsOverallRatingDecimalPlaces, proto.overallRatingDecimalPlaces);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.overallRatingDecimalPlaces !== 'undefined') {
      toReturn['overallRatingDecimalPlaces'] = this.overallRatingDecimalPlaces;
    }
    if (typeof this.headerText !== 'undefined') {
      toReturn['headerText'] = this.headerText;
    }
    return toReturn;
  }
}
class GetReviewWidgetByIDRequest {
  static fromProto(proto) {
    let m = new GetReviewWidgetByIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    return toReturn;
  }
}
class GetReviewWidgetByIDResponse {
  static fromProto(proto) {
    let m = new GetReviewWidgetByIDResponse();
    m = Object.assign(m, proto);
    if (proto.reviewWidget) {
      m.reviewWidget = ReviewWidget.fromProto(proto.reviewWidget);
    }
    if (proto.reviewStats) {
      m.reviewStats = ReviewStats.fromProto(proto.reviewStats);
    }
    if (proto.leaveReviewUrls) {
      m.leaveReviewUrls = Object.keys(proto.leaveReviewUrls).reduce((obj, k) => {
        obj[k] = proto.leaveReviewUrls[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewWidget !== 'undefined' && this.reviewWidget !== null) {
      toReturn['reviewWidget'] = 'toApiJson' in this.reviewWidget ? this.reviewWidget.toApiJson() : this.reviewWidget;
    }
    if (typeof this.reviewStats !== 'undefined' && this.reviewStats !== null) {
      toReturn['reviewStats'] = 'toApiJson' in this.reviewStats ? this.reviewStats.toApiJson() : this.reviewStats;
    }
    if (typeof this.leaveReviewUrls !== 'undefined' && this.leaveReviewUrls !== null) {
      toReturn['leaveReviewUrls'] = 'toApiJson' in this.leaveReviewUrls ? this.leaveReviewUrls.toApiJson() : this.leaveReviewUrls;
    }
    return toReturn;
  }
}
class GetReviewWidgetRequest {
  static fromProto(proto) {
    let m = new GetReviewWidgetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetReviewWidgetResponse {
  static fromProto(proto) {
    let m = new GetReviewWidgetResponse();
    m = Object.assign(m, proto);
    if (proto.reviewWidget) {
      m.reviewWidget = ReviewWidget.fromProto(proto.reviewWidget);
    }
    if (proto.reviewStats) {
      m.reviewStats = ReviewStats.fromProto(proto.reviewStats);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewWidget !== 'undefined' && this.reviewWidget !== null) {
      toReturn['reviewWidget'] = 'toApiJson' in this.reviewWidget ? this.reviewWidget.toApiJson() : this.reviewWidget;
    }
    if (typeof this.reviewStats !== 'undefined' && this.reviewStats !== null) {
      toReturn['reviewStats'] = 'toApiJson' in this.reviewStats ? this.reviewStats.toApiJson() : this.reviewStats;
    }
    return toReturn;
  }
}
class GetReviewWidgetByIDResponseLeaveReviewUrlsEntry {
  static fromProto(proto) {
    let m = new GetReviewWidgetByIDResponseLeaveReviewUrlsEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ListWidgetReviewsRequest {
  static fromProto(proto) {
    let m = new ListWidgetReviewsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.minimumRating) {
      m.minimumRating = enumStringToValue$3(ListWidgetReviewsRequestMinimumRating, proto.minimumRating);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.minimumRating !== 'undefined') {
      toReturn['minimumRating'] = this.minimumRating;
    }
    return toReturn;
  }
}
class ListWidgetReviewsResponse {
  static fromProto(proto) {
    let m = new ListWidgetReviewsResponse();
    m = Object.assign(m, proto);
    if (proto.reviews) {
      m.reviews = proto.reviews.map(Review.fromProto);
    }
    if (proto.totalHits) {
      m.totalHits = parseInt(proto.totalHits, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviews !== 'undefined' && this.reviews !== null) {
      toReturn['reviews'] = 'toApiJson' in this.reviews ? this.reviews.toApiJson() : this.reviews;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalHits !== 'undefined') {
      toReturn['totalHits'] = this.totalHits;
    }
    return toReturn;
  }
}
class ReviewStats {
  static fromProto(proto) {
    let m = new ReviewStats();
    m = Object.assign(m, proto);
    if (proto.totalCount) {
      m.totalCount = parseInt(proto.totalCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.averageRating !== 'undefined') {
      toReturn['averageRating'] = this.averageRating;
    }
    if (typeof this.totalCount !== 'undefined') {
      toReturn['totalCount'] = this.totalCount;
    }
    return toReturn;
  }
}
class ReviewWidget {
  static fromProto(proto) {
    let m = new ReviewWidget();
    m = Object.assign(m, proto);
    if (proto.customizations) {
      m.customizations = Customizations.fromProto(proto.customizations);
    }
    if (proto.toggles) {
      m.toggles = Toggles.fromProto(proto.toggles);
    }
    if (proto.styling) {
      m.styling = Styling.fromProto(proto.styling);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.leaveReviewDestination !== 'undefined') {
      toReturn['leaveReviewDestination'] = this.leaveReviewDestination;
    }
    if (typeof this.customizations !== 'undefined' && this.customizations !== null) {
      toReturn['customizations'] = 'toApiJson' in this.customizations ? this.customizations.toApiJson() : this.customizations;
    }
    if (typeof this.toggles !== 'undefined' && this.toggles !== null) {
      toReturn['toggles'] = 'toApiJson' in this.toggles ? this.toggles.toApiJson() : this.toggles;
    }
    if (typeof this.styling !== 'undefined' && this.styling !== null) {
      toReturn['styling'] = 'toApiJson' in this.styling ? this.styling.toApiJson() : this.styling;
    }
    return toReturn;
  }
}
class Styling {
  static fromProto(proto) {
    let m = new Styling();
    m = Object.assign(m, proto);
    if (proto.theme) {
      m.theme = enumStringToValue$3(StylingTheme, proto.theme);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.theme !== 'undefined') {
      toReturn['theme'] = this.theme;
    }
    if (typeof this.accentColour !== 'undefined') {
      toReturn['accentColour'] = this.accentColour;
    }
    return toReturn;
  }
}
class Toggles {
  static fromProto(proto) {
    let m = new Toggles();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.showOverallRatingTitle !== 'undefined') {
      toReturn['showOverallRatingTitle'] = this.showOverallRatingTitle;
    }
    if (typeof this.showOverallRatingCard !== 'undefined') {
      toReturn['showOverallRatingCard'] = this.showOverallRatingCard;
    }
    if (typeof this.showReviewCount !== 'undefined') {
      toReturn['showReviewCount'] = this.showReviewCount;
    }
    if (typeof this.showLeaveAReviewButton !== 'undefined') {
      toReturn['showLeaveAReviewButton'] = this.showLeaveAReviewButton;
    }
    if (typeof this.showHeader !== 'undefined') {
      toReturn['showHeader'] = this.showHeader;
    }
    if (typeof this.showStarRatingSummary !== 'undefined') {
      toReturn['showStarRatingSummary'] = this.showStarRatingSummary;
    }
    if (typeof this.showReviewSource !== 'undefined') {
      toReturn['showReviewSource'] = this.showReviewSource;
    }
    if (typeof this.showReviewStarRating !== 'undefined') {
      toReturn['showReviewStarRating'] = this.showReviewStarRating;
    }
    if (typeof this.showReviewPublishedDate !== 'undefined') {
      toReturn['showReviewPublishedDate'] = this.showReviewPublishedDate;
    }
    return toReturn;
  }
}
class UpdateReviewWidgetRequest {
  static fromProto(proto) {
    let m = new UpdateReviewWidgetRequest();
    m = Object.assign(m, proto);
    if (proto.reviewWidget) {
      m.reviewWidget = ReviewWidget.fromProto(proto.reviewWidget);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewWidget !== 'undefined' && this.reviewWidget !== null) {
      toReturn['reviewWidget'] = 'toApiJson' in this.reviewWidget ? this.reviewWidget.toApiJson() : this.reviewWidget;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class MethodMetadata {
  static fromProto(proto) {
    let m = new MethodMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isPublic !== 'undefined') {
      toReturn['isPublic'] = this.isPublic;
    }
    if (typeof this.scopes !== 'undefined') {
      toReturn['scopes'] = this.scopes;
    }
    return toReturn;
  }
}
class SDKMetadata {
  static fromProto(proto) {
    let m = new SDKMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sdkName !== 'undefined') {
      toReturn['sdkName'] = this.sdkName;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ApproveReviewResponseRequest {
  static fromProto(proto) {
    let m = new ApproveReviewResponseRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class SourceAttributeScope {
  static fromProto(proto) {
    let m = new SourceAttributeScope();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.whitelist !== 'undefined') {
      toReturn['whitelist'] = this.whitelist;
    }
    if (typeof this.blacklist !== 'undefined') {
      toReturn['blacklist'] = this.blacklist;
    }
    if (typeof this.isWhitelistedByDefault !== 'undefined') {
      toReturn['isWhitelistedByDefault'] = this.isWhitelistedByDefault;
    }
    return toReturn;
  }
}
class CanRespondToReviewRequest {
  static fromProto(proto) {
    let m = new CanRespondToReviewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    return toReturn;
  }
}
class CanRespondToReviewResponse {
  static fromProto(proto) {
    let m = new CanRespondToReviewResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.canRespond !== 'undefined') {
      toReturn['canRespond'] = this.canRespond;
    }
    if (typeof this.unsupportedReason !== 'undefined') {
      toReturn['unsupportedReason'] = this.unsupportedReason;
    }
    return toReturn;
  }
}
class CreateBrandReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new CreateBrandReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewResponseTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class CreateBusinessReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new CreateBusinessReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewResponseTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class CreateDefaultReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new CreateDefaultReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewResponseTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class CreateDigitalAgentReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new CreateDigitalAgentReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewResponseTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class CreatePartnerMarketReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new CreatePartnerMarketReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewResponseTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class CreateReviewCommentRequest {
  static fromProto(proto) {
    let m = new CreateReviewCommentRequest();
    m = Object.assign(m, proto);
    if (proto.reviewId) {
      m.reviewId = ReviewIdentifier.fromProto(proto.reviewId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined' && this.reviewId !== null) {
      toReturn['reviewId'] = 'toApiJson' in this.reviewId ? this.reviewId.toApiJson() : this.reviewId;
    }
    if (typeof this.commentText !== 'undefined') {
      toReturn['commentText'] = this.commentText;
    }
    if (typeof this.commenterEmail !== 'undefined') {
      toReturn['commenterEmail'] = this.commenterEmail;
    }
    if (typeof this.commenterName !== 'undefined') {
      toReturn['commenterName'] = this.commenterName;
    }
    if (typeof this.postedByOwner !== 'undefined') {
      toReturn['postedByOwner'] = this.postedByOwner;
    }
    if (typeof this.shouldPublish !== 'undefined') {
      toReturn['shouldPublish'] = this.shouldPublish;
    }
    if (typeof this.postedByDigitalAgent !== 'undefined') {
      toReturn['postedByDigitalAgent'] = this.postedByDigitalAgent;
    }
    return toReturn;
  }
}
class CreateReviewCommentResponse {
  static fromProto(proto) {
    let m = new CreateReviewCommentResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.published) {
      m.published = new Date(proto.published);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commentId !== 'undefined') {
      toReturn['commentId'] = this.commentId;
    }
    if (typeof this.commentText !== 'undefined') {
      toReturn['commentText'] = this.commentText;
    }
    if (typeof this.commenterName !== 'undefined') {
      toReturn['commenterName'] = this.commenterName;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.published !== 'undefined' && this.published !== null) {
      toReturn['published'] = 'toApiJson' in this.published ? this.published.toApiJson() : this.published;
    }
    if (typeof this.postedByOwner !== 'undefined') {
      toReturn['postedByOwner'] = this.postedByOwner;
    }
    return toReturn;
  }
}
class CreateReviewRequestEmailTemplateRequest {
  static fromProto(proto) {
    let m = new CreateReviewRequestEmailTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class CreateReviewRequestEmailTemplateResponse {
  static fromProto(proto) {
    let m = new CreateReviewRequestEmailTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewRequestTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class CreateReviewResponseTemplateResponse {
  static fromProto(proto) {
    let m = new CreateReviewResponseTemplateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.responseTemplateId !== 'undefined') {
      toReturn['responseTemplateId'] = this.responseTemplateId;
    }
    return toReturn;
  }
}
class DeleteBrandReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteBrandReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.responseTemplateId !== 'undefined') {
      toReturn['responseTemplateId'] = this.responseTemplateId;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    return toReturn;
  }
}
class DeleteBusinessReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteBusinessReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.responseTemplateId !== 'undefined') {
      toReturn['responseTemplateId'] = this.responseTemplateId;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    return toReturn;
  }
}
class DeleteDefaultReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteDefaultReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.responseTemplateId !== 'undefined') {
      toReturn['responseTemplateId'] = this.responseTemplateId;
    }
    return toReturn;
  }
}
class DeleteDigitalAgentReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteDigitalAgentReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.responseTemplateId !== 'undefined') {
      toReturn['responseTemplateId'] = this.responseTemplateId;
    }
    return toReturn;
  }
}
class DeletePartnerMarketReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new DeletePartnerMarketReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.responseTemplateId !== 'undefined') {
      toReturn['responseTemplateId'] = this.responseTemplateId;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    return toReturn;
  }
}
class DeleteReviewRequestTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteReviewRequestTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class EmailTemplateData {
  static fromProto(proto) {
    let m = new EmailTemplateData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailTemplateSubject !== 'undefined') {
      toReturn['emailTemplateSubject'] = this.emailTemplateSubject;
    }
    if (typeof this.emailTemplateHtml !== 'undefined') {
      toReturn['emailTemplateHtml'] = this.emailTemplateHtml;
    }
    return toReturn;
  }
}
class ForceRefreshListingRequest {
  static fromProto(proto) {
    let m = new ForceRefreshListingRequest();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    if (typeof this.listingUrl !== 'undefined') {
      toReturn['listingUrl'] = this.listingUrl;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class GetBusinessSourcesRequest {
  static fromProto(proto) {
    let m = new GetBusinessSourcesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    return toReturn;
  }
}
class GetBusinessSourcesResponse {
  static fromProto(proto) {
    let m = new GetBusinessSourcesResponse();
    m = Object.assign(m, proto);
    if (proto.sourceDetails) {
      m.sourceDetails = proto.sourceDetails.map(SourceDetails.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceDetails !== 'undefined' && this.sourceDetails !== null) {
      toReturn['sourceDetails'] = 'toApiJson' in this.sourceDetails ? this.sourceDetails.toApiJson() : this.sourceDetails;
    }
    return toReturn;
  }
}
class GetLimitRequest {
  static fromProto(proto) {
    let m = new GetLimitRequest();
    m = Object.assign(m, proto);
    if (proto.limitType) {
      m.limitType = enumStringToValue(LimitType, proto.limitType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.limitType !== 'undefined') {
      toReturn['limitType'] = this.limitType;
    }
    return toReturn;
  }
}
class GetLimitResponse {
  static fromProto(proto) {
    let m = new GetLimitResponse();
    m = Object.assign(m, proto);
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    if (proto.usage) {
      m.usage = parseInt(proto.usage, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.usage !== 'undefined') {
      toReturn['usage'] = this.usage;
    }
    return toReturn;
  }
}
class GetListingsRequest {
  static fromProto(proto) {
    let m = new GetListingsRequest();
    m = Object.assign(m, proto);
    if (proto.listingIds) {
      m.listingIds = proto.listingIds.map(ListingIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingIds !== 'undefined' && this.listingIds !== null) {
      toReturn['listingIds'] = 'toApiJson' in this.listingIds ? this.listingIds.toApiJson() : this.listingIds;
    }
    return toReturn;
  }
}
class GetListingsResponse {
  static fromProto(proto) {
    let m = new GetListingsResponse();
    m = Object.assign(m, proto);
    if (proto.listings) {
      m.listings = proto.listings.map(Listing.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listings !== 'undefined' && this.listings !== null) {
      toReturn['listings'] = 'toApiJson' in this.listings ? this.listings.toApiJson() : this.listings;
    }
    return toReturn;
  }
}
class GetMultiThirdPartyReviewPublishSettingsRequest {
  static fromProto(proto) {
    let m = new GetMultiThirdPartyReviewPublishSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    return toReturn;
  }
}
class GetMultiThirdPartyReviewPublishSettingsResponse {
  static fromProto(proto) {
    let m = new GetMultiThirdPartyReviewPublishSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.thirdPartyReviewPublishSettings) {
      m.thirdPartyReviewPublishSettings = Object.keys(proto.thirdPartyReviewPublishSettings).reduce((obj, k) => {
        obj[k] = ThirdPartyReviewPublishSettings.fromProto(proto.thirdPartyReviewPublishSettings[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.thirdPartyReviewPublishSettings !== 'undefined' && this.thirdPartyReviewPublishSettings !== null) {
      toReturn['thirdPartyReviewPublishSettings'] = 'toApiJson' in this.thirdPartyReviewPublishSettings ? this.thirdPartyReviewPublishSettings.toApiJson() : this.thirdPartyReviewPublishSettings;
    }
    return toReturn;
  }
}
class GetReviewRequestEmailTemplateRequest {
  static fromProto(proto) {
    let m = new GetReviewRequestEmailTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class GetReviewRequestEmailTemplateResponse {
  static fromProto(proto) {
    let m = new GetReviewRequestEmailTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewRequestTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class GetReviewResponseRequest {
  static fromProto(proto) {
    let m = new GetReviewResponseRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetReviewResponseResponse {
  static fromProto(proto) {
    let m = new GetReviewResponseResponse();
    m = Object.assign(m, proto);
    if (proto.reviewResponse) {
      m.reviewResponse = ConciergeReviewResponse.fromProto(proto.reviewResponse);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewResponse !== 'undefined' && this.reviewResponse !== null) {
      toReturn['reviewResponse'] = 'toApiJson' in this.reviewResponse ? this.reviewResponse.toApiJson() : this.reviewResponse;
    }
    return toReturn;
  }
}
class GetReviewsRequest {
  static fromProto(proto) {
    let m = new GetReviewsRequest();
    m = Object.assign(m, proto);
    if (proto.reviewIds) {
      m.reviewIds = proto.reviewIds.map(ReviewIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewIds !== 'undefined' && this.reviewIds !== null) {
      toReturn['reviewIds'] = 'toApiJson' in this.reviewIds ? this.reviewIds.toApiJson() : this.reviewIds;
    }
    if (typeof this.includeComments !== 'undefined') {
      toReturn['includeComments'] = this.includeComments;
    }
    return toReturn;
  }
}
class GetReviewsResponse {
  static fromProto(proto) {
    let m = new GetReviewsResponse();
    m = Object.assign(m, proto);
    if (proto.reviews) {
      m.reviews = proto.reviews.map(Review.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviews !== 'undefined' && this.reviews !== null) {
      toReturn['reviews'] = 'toApiJson' in this.reviews ? this.reviews.toApiJson() : this.reviews;
    }
    return toReturn;
  }
}
class GetSourceDetailsRequest {
  static fromProto(proto) {
    let m = new GetSourceDetailsRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.taxIds !== 'undefined') {
      toReturn['taxIds'] = this.taxIds;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class GetSourceDetailsResponse {
  static fromProto(proto) {
    let m = new GetSourceDetailsResponse();
    m = Object.assign(m, proto);
    if (proto.sources) {
      m.sources = proto.sources.map(Source.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sources !== 'undefined' && this.sources !== null) {
      toReturn['sources'] = 'toApiJson' in this.sources ? this.sources.toApiJson() : this.sources;
    }
    return toReturn;
  }
}
class SourceHTML {
  static fromProto(proto) {
    let m = new SourceHTML();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.claimListing !== 'undefined') {
      toReturn['claimListing'] = this.claimListing;
    }
    if (typeof this.editListing !== 'undefined') {
      toReturn['editListing'] = this.editListing;
    }
    if (typeof this.createListing !== 'undefined') {
      toReturn['createListing'] = this.createListing;
    }
    return toReturn;
  }
}
class SourceIcon {
  static fromProto(proto) {
    let m = new SourceIcon();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url16px !== 'undefined') {
      toReturn['url16px'] = this.url16px;
    }
    if (typeof this.url32px !== 'undefined') {
      toReturn['url32px'] = this.url32px;
    }
    if (typeof this.url50px !== 'undefined') {
      toReturn['url50px'] = this.url50px;
    }
    return toReturn;
  }
}
class ListBusinessReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new ListBusinessReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.isDigitalAgent !== 'undefined') {
      toReturn['isDigitalAgent'] = this.isDigitalAgent;
    }
    return toReturn;
  }
}
class ListBusinessReviewResponseTemplateResponse {
  static fromProto(proto) {
    let m = new ListBusinessReviewResponseTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(ReviewResponseTemplate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    return toReturn;
  }
}
class ListReviewRequestEmailTemplatesRequest {
  static fromProto(proto) {
    let m = new ListReviewRequestEmailTemplatesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.searchOptions) {
      m.searchOptions = ListReviewRequestEmailTemplatesRequestSearchOptions.fromProto(proto.searchOptions);
    }
    if (proto.sortOptions) {
      m.sortOptions = ListReviewRequestEmailTemplatesRequestSortOptions.fromProto(proto.sortOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.searchOptions !== 'undefined' && this.searchOptions !== null) {
      toReturn['searchOptions'] = 'toApiJson' in this.searchOptions ? this.searchOptions.toApiJson() : this.searchOptions;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    return toReturn;
  }
}
class ListReviewRequestEmailTemplatesResponse {
  static fromProto(proto) {
    let m = new ListReviewRequestEmailTemplatesResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(ReviewRequestTemplate.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class Listing {
  static fromProto(proto) {
    let m = new Listing();
    m = Object.assign(m, proto);
    if (proto.listingIdentifier) {
      m.listingIdentifier = ListingIdentifier.fromProto(proto.listingIdentifier);
    }
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.nap) {
      m.nap = NAP.fromProto(proto.nap);
    }
    if (proto.matchQuality) {
      m.matchQuality = enumStringToValue(ListingMatchQuality, proto.matchQuality);
    }
    if (proto.score) {
      m.score = parseInt(proto.score, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.lastScraped) {
      m.lastScraped = new Date(proto.lastScraped);
    }
    if (proto.lastUserRefresh) {
      m.lastUserRefresh = new Date(proto.lastUserRefresh);
    }
    if (proto.missingOn) {
      m.missingOn = new Date(proto.missingOn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingIdentifier !== 'undefined' && this.listingIdentifier !== null) {
      toReturn['listingIdentifier'] = 'toApiJson' in this.listingIdentifier ? this.listingIdentifier.toApiJson() : this.listingIdentifier;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.nap !== 'undefined' && this.nap !== null) {
      toReturn['nap'] = 'toApiJson' in this.nap ? this.nap.toApiJson() : this.nap;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.matchQuality !== 'undefined') {
      toReturn['matchQuality'] = this.matchQuality;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.userSubmitted !== 'undefined') {
      toReturn['userSubmitted'] = this.userSubmitted;
    }
    if (typeof this.verified !== 'undefined') {
      toReturn['verified'] = this.verified;
    }
    if (typeof this.missing !== 'undefined') {
      toReturn['missing'] = this.missing;
    }
    if (typeof this.matches !== 'undefined') {
      toReturn['matches'] = this.matches;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.lastScraped !== 'undefined' && this.lastScraped !== null) {
      toReturn['lastScraped'] = 'toApiJson' in this.lastScraped ? this.lastScraped.toApiJson() : this.lastScraped;
    }
    if (typeof this.lastUserRefresh !== 'undefined' && this.lastUserRefresh !== null) {
      toReturn['lastUserRefresh'] = 'toApiJson' in this.lastUserRefresh ? this.lastUserRefresh.toApiJson() : this.lastUserRefresh;
    }
    if (typeof this.missingOn !== 'undefined' && this.missingOn !== null) {
      toReturn['missingOn'] = 'toApiJson' in this.missingOn ? this.missingOn.toApiJson() : this.missingOn;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class ListingIdentifier {
  static fromProto(proto) {
    let m = new ListingIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    return toReturn;
  }
}
class SourceListingInteractionHTML {
  static fromProto(proto) {
    let m = new SourceListingInteractionHTML();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.descriptionHtml !== 'undefined') {
      toReturn['descriptionHtml'] = this.descriptionHtml;
    }
    if (typeof this.claimListingHtml !== 'undefined') {
      toReturn['claimListingHtml'] = this.claimListingHtml;
    }
    if (typeof this.editListingHtml !== 'undefined') {
      toReturn['editListingHtml'] = this.editListingHtml;
    }
    if (typeof this.createListingHtml !== 'undefined') {
      toReturn['createListingHtml'] = this.createListingHtml;
    }
    return toReturn;
  }
}
class LookupListingsRequest {
  static fromProto(proto) {
    let m = new LookupListingsRequest();
    m = Object.assign(m, proto);
    if (proto.sourceIds) {
      m.sourceIds = proto.sourceIds.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    if (typeof this.includeAnchorDataMatches !== 'undefined') {
      toReturn['includeAnchorDataMatches'] = this.includeAnchorDataMatches;
    }
    if (typeof this.includeGoodListings !== 'undefined') {
      toReturn['includeGoodListings'] = this.includeGoodListings;
    }
    if (typeof this.includeInternetProviderListings !== 'undefined') {
      toReturn['includeInternetProviderListings'] = this.includeInternetProviderListings;
    }
    if (typeof this.includeNotDoneListings !== 'undefined') {
      toReturn['includeNotDoneListings'] = this.includeNotDoneListings;
    }
    if (typeof this.includePoorListings !== 'undefined') {
      toReturn['includePoorListings'] = this.includePoorListings;
    }
    return toReturn;
  }
}
class LookupListingsResponse {
  static fromProto(proto) {
    let m = new LookupListingsResponse();
    m = Object.assign(m, proto);
    if (proto.listingsBySource) {
      m.listingsBySource = proto.listingsBySource.map(LookupResponseForSource.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingsBySource !== 'undefined' && this.listingsBySource !== null) {
      toReturn['listingsBySource'] = 'toApiJson' in this.listingsBySource ? this.listingsBySource.toApiJson() : this.listingsBySource;
    }
    return toReturn;
  }
}
class LookupResponseForSource {
  static fromProto(proto) {
    let m = new LookupResponseForSource();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.poorListings) {
      m.poorListings = proto.poorListings.map(Listing.fromProto);
    }
    if (proto.goodListings) {
      m.goodListings = proto.goodListings.map(Listing.fromProto);
    }
    if (proto.notDoneListings) {
      m.notDoneListings = proto.notDoneListings.map(Listing.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceName !== 'undefined') {
      toReturn['sourceName'] = this.sourceName;
    }
    if (typeof this.userFriendlySourceName !== 'undefined') {
      toReturn['userFriendlySourceName'] = this.userFriendlySourceName;
    }
    if (typeof this.poorListings !== 'undefined' && this.poorListings !== null) {
      toReturn['poorListings'] = 'toApiJson' in this.poorListings ? this.poorListings.toApiJson() : this.poorListings;
    }
    if (typeof this.goodListings !== 'undefined' && this.goodListings !== null) {
      toReturn['goodListings'] = 'toApiJson' in this.goodListings ? this.goodListings.toApiJson() : this.goodListings;
    }
    if (typeof this.notDoneListings !== 'undefined' && this.notDoneListings !== null) {
      toReturn['notDoneListings'] = 'toApiJson' in this.notDoneListings ? this.notDoneListings.toApiJson() : this.notDoneListings;
    }
    return toReturn;
  }
}
class NAP {
  static fromProto(proto) {
    let m = new NAP();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ProvideFeedbackToReviewResponseRequest {
  static fromProto(proto) {
    let m = new ProvideFeedbackToReviewResponseRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.feedback !== 'undefined') {
      toReturn['feedback'] = this.feedback;
    }
    return toReturn;
  }
}
class RefreshBusisinessSourceRequest {
  static fromProto(proto) {
    let m = new RefreshBusisinessSourceRequest();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    return toReturn;
  }
}
class ReviewHistoryRequest {
  static fromProto(proto) {
    let m = new ReviewHistoryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    return toReturn;
  }
}
class ReviewHistoryResponse {
  static fromProto(proto) {
    let m = new ReviewHistoryResponse();
    m = Object.assign(m, proto);
    if (proto.reviewHistory) {
      m.reviewHistory = proto.reviewHistory.map(ReviewHistory.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewHistory !== 'undefined' && this.reviewHistory !== null) {
      toReturn['reviewHistory'] = 'toApiJson' in this.reviewHistory ? this.reviewHistory.toApiJson() : this.reviewHistory;
    }
    return toReturn;
  }
}
class ReviewResponseTemplate {
  static fromProto(proto) {
    let m = new ReviewResponseTemplate();
    m = Object.assign(m, proto);
    if (proto.ratings) {
      m.ratings = proto.ratings.map(i => parseInt(i, 10));
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.categories !== 'undefined') {
      toReturn['categories'] = this.categories;
    }
    if (typeof this.ratings !== 'undefined') {
      toReturn['ratings'] = this.ratings;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.responseTemplateId !== 'undefined') {
      toReturn['responseTemplateId'] = this.responseTemplateId;
    }
    if (typeof this.externalTemplateId !== 'undefined') {
      toReturn['externalTemplateId'] = this.externalTemplateId;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    return toReturn;
  }
}
class ListReviewRequestEmailTemplatesRequestSearchOptions {
  static fromProto(proto) {
    let m = new ListReviewRequestEmailTemplatesRequestSearchOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.exactMatch !== 'undefined') {
      toReturn['exactMatch'] = this.exactMatch;
    }
    return toReturn;
  }
}
class SendReviewRequestEmailRequest {
  static fromProto(proto) {
    let m = new SendReviewRequestEmailRequest();
    m = Object.assign(m, proto);
    if (proto.emailTemplateData) {
      m.emailTemplateData = EmailTemplateData.fromProto(proto.emailTemplateData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientsEmails !== 'undefined') {
      toReturn['recipientsEmails'] = this.recipientsEmails;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.emailTemplateData !== 'undefined' && this.emailTemplateData !== null) {
      toReturn['emailTemplateData'] = 'toApiJson' in this.emailTemplateData ? this.emailTemplateData.toApiJson() : this.emailTemplateData;
    }
    if (typeof this.contactIds !== 'undefined') {
      toReturn['contactIds'] = this.contactIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class SendReviewRequestRequest {
  static fromProto(proto) {
    let m = new SendReviewRequestRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.contactIds !== 'undefined') {
      toReturn['contactIds'] = this.contactIds;
    }
    return toReturn;
  }
}
class SendReviewRequestSmsRequest {
  static fromProto(proto) {
    let m = new SendReviewRequestSmsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.contactIds !== 'undefined') {
      toReturn['contactIds'] = this.contactIds;
    }
    if (typeof this.messageText !== 'undefined') {
      toReturn['messageText'] = this.messageText;
    }
    return toReturn;
  }
}
class SetDefaultReviewRequestTemplateRequest {
  static fromProto(proto) {
    let m = new SetDefaultReviewRequestTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class ListReviewRequestEmailTemplatesRequestSortOptions {
  static fromProto(proto) {
    let m = new ListReviewRequestEmailTemplatesRequestSortOptions();
    m = Object.assign(m, proto);
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue(SortDirection, proto.sortDirection);
    }
    if (proto.sortField) {
      m.sortField = enumStringToValue(ListReviewRequestEmailTemplatesRequestSortField, proto.sortField);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    if (typeof this.sortField !== 'undefined') {
      toReturn['sortField'] = this.sortField;
    }
    return toReturn;
  }
}
class Source {
  static fromProto(proto) {
    let m = new Source();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.icon) {
      m.icon = SourceIcon.fromProto(proto.icon);
    }
    if (proto.partner) {
      m.partner = SourceAttributeScope.fromProto(proto.partner);
    }
    if (proto.location) {
      m.location = SourceAttributeScope.fromProto(proto.location);
    }
    if (proto.taxonomy) {
      m.taxonomy = SourceAttributeScope.fromProto(proto.taxonomy);
    }
    if (proto.submitListingData) {
      m.submitListingData = SourceSubmitListing.fromProto(proto.submitListingData);
    }
    if (proto.listingInteractionHtml) {
      m.listingInteractionHtml = SourceListingInteractionHTML.fromProto(proto.listingInteractionHtml);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.sourceTypeName !== 'undefined') {
      toReturn['sourceTypeName'] = this.sourceTypeName;
    }
    if (typeof this.sourceTypeId !== 'undefined') {
      toReturn['sourceTypeId'] = this.sourceTypeId;
    }
    if (typeof this.icon !== 'undefined' && this.icon !== null) {
      toReturn['icon'] = 'toApiJson' in this.icon ? this.icon.toApiJson() : this.icon;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.hasReviews !== 'undefined') {
      toReturn['hasReviews'] = this.hasReviews;
    }
    if (typeof this.hasNoRatingsReviews !== 'undefined') {
      toReturn['hasNoRatingsReviews'] = this.hasNoRatingsReviews;
    }
    if (typeof this.hasListings !== 'undefined') {
      toReturn['hasListings'] = this.hasListings;
    }
    if (typeof this.adminNotes !== 'undefined') {
      toReturn['adminNotes'] = this.adminNotes;
    }
    if (typeof this.supportsSubmittingListings !== 'undefined') {
      toReturn['supportsSubmittingListings'] = this.supportsSubmittingListings;
    }
    if (typeof this.ignoredAnchorDataMatches !== 'undefined') {
      toReturn['ignoredAnchorDataMatches'] = this.ignoredAnchorDataMatches;
    }
    if (typeof this.partner !== 'undefined' && this.partner !== null) {
      toReturn['partner'] = 'toApiJson' in this.partner ? this.partner.toApiJson() : this.partner;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    if (typeof this.taxonomy !== 'undefined' && this.taxonomy !== null) {
      toReturn['taxonomy'] = 'toApiJson' in this.taxonomy ? this.taxonomy.toApiJson() : this.taxonomy;
    }
    if (typeof this.submitListingData !== 'undefined' && this.submitListingData !== null) {
      toReturn['submitListingData'] = 'toApiJson' in this.submitListingData ? this.submitListingData.toApiJson() : this.submitListingData;
    }
    if (typeof this.listingInteractionHtml !== 'undefined' && this.listingInteractionHtml !== null) {
      toReturn['listingInteractionHtml'] = 'toApiJson' in this.listingInteractionHtml ? this.listingInteractionHtml.toApiJson() : this.listingInteractionHtml;
    }
    return toReturn;
  }
}
class SourceDetails {
  static fromProto(proto) {
    let m = new SourceDetails();
    m = Object.assign(m, proto);
    if (proto.sources) {
      m.sources = proto.sources.map(i => parseInt(i, 10));
    }
    if (proto.ignoredSources) {
      m.ignoredSources = proto.ignoredSources.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sources !== 'undefined') {
      toReturn['sources'] = this.sources;
    }
    if (typeof this.ignoredSources !== 'undefined') {
      toReturn['ignoredSources'] = this.ignoredSources;
    }
    return toReturn;
  }
}
class SourceSubmitListing {
  static fromProto(proto) {
    let m = new SourceSubmitListing();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.validationRegex !== 'undefined') {
      toReturn['validationRegex'] = this.validationRegex;
    }
    if (typeof this.helpText !== 'undefined') {
      toReturn['helpText'] = this.helpText;
    }
    if (typeof this.editListingUrl !== 'undefined') {
      toReturn['editListingUrl'] = this.editListingUrl;
    }
    if (typeof this.createListingUrl !== 'undefined') {
      toReturn['createListingUrl'] = this.createListingUrl;
    }
    return toReturn;
  }
}
class SubmitListingRequest {
  static fromProto(proto) {
    let m = new SubmitListingRequest();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.listingUrl !== 'undefined') {
      toReturn['listingUrl'] = this.listingUrl;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class SubmitListingResponse {
  static fromProto(proto) {
    let m = new SubmitListingResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    return toReturn;
  }
}
class SuggestReviewResponseRequest {
  static fromProto(proto) {
    let m = new SuggestReviewResponseRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.inSameLanguage !== 'undefined') {
      toReturn['inSameLanguage'] = this.inSameLanguage;
    }
    return toReturn;
  }
}
class SuggestReviewResponseResponse {
  static fromProto(proto) {
    let m = new SuggestReviewResponseResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class GetMultiThirdPartyReviewPublishSettingsResponseThirdPartyReviewPublishSettingsEntry {
  static fromProto(proto) {
    let m = new GetMultiThirdPartyReviewPublishSettingsResponseThirdPartyReviewPublishSettingsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ThirdPartyReviewPublishSettings.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class UpdateBrandReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateBrandReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewResponseTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    return toReturn;
  }
}
class UpdateBusinessReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateBusinessReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewResponseTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class UpdateDigitalAgentReviewResponseTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateDigitalAgentReviewResponseTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewResponseTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class UpdateListingRequest {
  static fromProto(proto) {
    let m = new UpdateListingRequest();
    m = Object.assign(m, proto);
    if (proto.listingId) {
      m.listingId = ListingIdentifier.fromProto(proto.listingId);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingId !== 'undefined' && this.listingId !== null) {
      toReturn['listingId'] = 'toApiJson' in this.listingId ? this.listingId.toApiJson() : this.listingId;
    }
    if (typeof this.isMine !== 'undefined') {
      toReturn['isMine'] = this.isMine;
    }
    if (typeof this.isVerified !== 'undefined') {
      toReturn['isVerified'] = this.isVerified;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateReviewCommentRequest {
  static fromProto(proto) {
    let m = new UpdateReviewCommentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewCommentId !== 'undefined') {
      toReturn['reviewCommentId'] = this.reviewCommentId;
    }
    if (typeof this.reviewCommentContent !== 'undefined') {
      toReturn['reviewCommentContent'] = this.reviewCommentContent;
    }
    return toReturn;
  }
}
class UpdateReviewCommentResponse {
  static fromProto(proto) {
    let m = new UpdateReviewCommentResponse();
    m = Object.assign(m, proto);
    if (proto.reviewComment) {
      m.reviewComment = ReviewComment.fromProto(proto.reviewComment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewComment !== 'undefined' && this.reviewComment !== null) {
      toReturn['reviewComment'] = 'toApiJson' in this.reviewComment ? this.reviewComment.toApiJson() : this.reviewComment;
    }
    return toReturn;
  }
}
class UpdateReviewRequest {
  static fromProto(proto) {
    let m = new UpdateReviewRequest();
    m = Object.assign(m, proto);
    if (proto.reviewId) {
      m.reviewId = ReviewIdentifier.fromProto(proto.reviewId);
    }
    if (proto.actionStatus) {
      m.actionStatus = enumStringToValue(ReviewActionStatus, proto.actionStatus);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined' && this.reviewId !== null) {
      toReturn['reviewId'] = 'toApiJson' in this.reviewId ? this.reviewId.toApiJson() : this.reviewId;
    }
    if (typeof this.actionStatus !== 'undefined') {
      toReturn['actionStatus'] = this.actionStatus;
    }
    if (typeof this.isPublished !== 'undefined') {
      toReturn['isPublished'] = this.isPublished;
    }
    if (typeof this.isPublishedThirdPartyReview !== 'undefined') {
      toReturn['isPublishedThirdPartyReview'] = this.isPublishedThirdPartyReview;
    }
    if (typeof this.isSharedByReviewer !== 'undefined') {
      toReturn['isSharedByReviewer'] = this.isSharedByReviewer;
    }
    if (typeof this.newComment !== 'undefined') {
      toReturn['newComment'] = this.newComment;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateReviewRequestEmailTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateReviewRequestEmailTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = ReviewRequestTemplate.fromProto(proto.template);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateReviewResponse {
  static fromProto(proto) {
    let m = new UpdateReviewResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    return toReturn;
  }
}
class UpdateReviewUserDeletedInfoRequest {
  static fromProto(proto) {
    let m = new UpdateReviewUserDeletedInfoRequest();
    m = Object.assign(m, proto);
    if (proto.deletedStatus) {
      m.deletedStatus = enumStringToValue(ReviewDeletedStatus, proto.deletedStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.deletedStatus !== 'undefined') {
      toReturn['deletedStatus'] = this.deletedStatus;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'reputation-api.vendasta-local.com',
  'test': '',
  'demo': 'reputation-api-demo.apigateway.co',
  'prod': 'reputation-api-prod.apigateway.co',
  'production': 'reputation-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AccountApiService = /*#__PURE__*/(() => {
  class AccountApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSmsEnabled(r) {
      const request = r.toApiJson ? r : new GetSMSEnabledRequest(r);
      return this.http.post(this._host + "/reputation.v1.AccountService/GetSMSEnabled", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSMSEnabledResponse.fromProto(resp)));
    }
  }
  AccountApiService.ɵfac = function AccountApiService_Factory(t) {
    return new (t || AccountApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountApiService,
    factory: AccountApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConciergeReviewResponseApiService = /*#__PURE__*/(() => {
  class ConciergeReviewResponseApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getReviewResponse(r) {
      const request = r.toApiJson ? r : new GetReviewResponseRequest(r);
      return this.http.post(this._host + "/reputation.v1.ConciergeReviewResponseService/GetReviewResponse", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReviewResponseResponse.fromProto(resp)));
    }
    approveReviewResponse(r) {
      const request = r.toApiJson ? r : new ApproveReviewResponseRequest(r);
      return this.http.post(this._host + "/reputation.v1.ConciergeReviewResponseService/ApproveReviewResponse", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    provideFeedbackToReviewResponse(r) {
      const request = r.toApiJson ? r : new ProvideFeedbackToReviewResponseRequest(r);
      return this.http.post(this._host + "/reputation.v1.ConciergeReviewResponseService/ProvideFeedbackToReviewResponse", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ConciergeReviewResponseApiService.ɵfac = function ConciergeReviewResponseApiService_Factory(t) {
    return new (t || ConciergeReviewResponseApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ConciergeReviewResponseApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConciergeReviewResponseApiService,
    factory: ConciergeReviewResponseApiService.ɵfac,
    providedIn: 'root'
  });
  return ConciergeReviewResponseApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let LimitApiService = /*#__PURE__*/(() => {
  class LimitApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getLimit(r) {
      const request = r.toApiJson ? r : new GetLimitRequest(r);
      return this.http.post(this._host + "/reputation.v1.LimitService/GetLimit", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLimitResponse.fromProto(resp)));
    }
  }
  LimitApiService.ɵfac = function LimitApiService_Factory(t) {
    return new (t || LimitApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  LimitApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LimitApiService,
    factory: LimitApiService.ɵfac,
    providedIn: 'root'
  });
  return LimitApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ListingApiService = /*#__PURE__*/(() => {
  class ListingApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getListings(r) {
      const request = r.toApiJson ? r : new GetListingsRequest(r);
      return this.http.post(this._host + "/reputation.v1.ListingService/GetListings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingsResponse.fromProto(resp)));
    }
    lookupListings(r) {
      const request = r.toApiJson ? r : new LookupListingsRequest(r);
      return this.http.post(this._host + "/reputation.v1.ListingService/LookupListings", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupListingsResponse.fromProto(resp)));
    }
    updateListing(r) {
      const request = r.toApiJson ? r : new UpdateListingRequest(r);
      return this.http.post(this._host + "/reputation.v1.ListingService/UpdateListing", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    submitListing(r) {
      const request = r.toApiJson ? r : new SubmitListingRequest(r);
      return this.http.post(this._host + "/reputation.v1.ListingService/SubmitListing", request.toApiJson(), this.apiOptions()).pipe(map(resp => SubmitListingResponse.fromProto(resp)));
    }
    forceRefreshListing(r) {
      const request = r.toApiJson ? r : new ForceRefreshListingRequest(r);
      return this.http.post(this._host + "/reputation.v1.ListingService/ForceRefreshListing", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ListingApiService.ɵfac = function ListingApiService_Factory(t) {
    return new (t || ListingApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ListingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingApiService,
    factory: ListingApiService.ɵfac,
    providedIn: 'root'
  });
  return ListingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ReviewRequestApiService = /*#__PURE__*/(() => {
  class ReviewRequestApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    sendReviewRequestEmail(r) {
      const request = r.toApiJson ? r : new SendReviewRequestEmailRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/SendReviewRequestEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendReviewRequestSms(r) {
      const request = r.toApiJson ? r : new SendReviewRequestSmsRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/SendReviewRequestSms", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createReviewRequestEmailTemplate(r) {
      const request = r.toApiJson ? r : new CreateReviewRequestEmailTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/CreateReviewRequestEmailTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewRequestEmailTemplateResponse.fromProto(resp)));
    }
    getReviewRequestEmailTemplate(r) {
      const request = r.toApiJson ? r : new GetReviewRequestEmailTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/GetReviewRequestEmailTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReviewRequestEmailTemplateResponse.fromProto(resp)));
    }
    listReviewRequestEmailTemplates(r) {
      const request = r.toApiJson ? r : new ListReviewRequestEmailTemplatesRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/ListReviewRequestEmailTemplates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListReviewRequestEmailTemplatesResponse.fromProto(resp)));
    }
    setDefaultReviewRequestTemplate(r) {
      const request = r.toApiJson ? r : new SetDefaultReviewRequestTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/SetDefaultReviewRequestTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateReviewRequestEmailTemplate(r) {
      const request = r.toApiJson ? r : new UpdateReviewRequestEmailTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/UpdateReviewRequestEmailTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteReviewRequestEmailTemplate(r) {
      const request = r.toApiJson ? r : new DeleteReviewRequestTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/DeleteReviewRequestEmailTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendReviewRequest(r) {
      const request = r.toApiJson ? r : new SendReviewRequestRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/SendReviewRequest", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getLeaveReviewUrLs(r) {
      const request = r.toApiJson ? r : new GetLeaveReviewURLsRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewRequestService/GetLeaveReviewURLs", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLeaveReviewURLsResponse.fromProto(resp)));
    }
  }
  ReviewRequestApiService.ɵfac = function ReviewRequestApiService_Factory(t) {
    return new (t || ReviewRequestApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ReviewRequestApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ReviewRequestApiService,
    factory: ReviewRequestApiService.ɵfac,
    providedIn: 'root'
  });
  return ReviewRequestApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ReviewResponseTemplateApiService = /*#__PURE__*/(() => {
  class ReviewResponseTemplateApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createBusinessReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new CreateBusinessReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/CreateBusinessReviewResponseTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewResponseTemplateResponse.fromProto(resp)));
    }
    createPartnerMarketReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new CreatePartnerMarketReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/CreatePartnerMarketReviewResponseTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewResponseTemplateResponse.fromProto(resp)));
    }
    createBrandReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new CreateBrandReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/CreateBrandReviewResponseTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewResponseTemplateResponse.fromProto(resp)));
    }
    createDigitalAgentReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new CreateDigitalAgentReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/CreateDigitalAgentReviewResponseTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewResponseTemplateResponse.fromProto(resp)));
    }
    createDefaultReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new CreateDefaultReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/CreateDefaultReviewResponseTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewResponseTemplateResponse.fromProto(resp)));
    }
    updateBusinessReviewResponseTemplates(r) {
      const request = r.toApiJson ? r : new UpdateBusinessReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/UpdateBusinessReviewResponseTemplates", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateBrandReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new UpdateBrandReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/UpdateBrandReviewResponseTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateDigitalAgentReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new UpdateDigitalAgentReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/UpdateDigitalAgentReviewResponseTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteBusinessReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new DeleteBusinessReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/DeleteBusinessReviewResponseTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deletePartnerMarketReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new DeletePartnerMarketReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/DeletePartnerMarketReviewResponseTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteBrandReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new DeleteBrandReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/DeleteBrandReviewResponseTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteDigitalAgentReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new DeleteDigitalAgentReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/DeleteDigitalAgentReviewResponseTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteDefaultReviewResponseTemplate(r) {
      const request = r.toApiJson ? r : new DeleteDefaultReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/DeleteDefaultReviewResponseTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listBusinessReviewResponseTemplates(r) {
      const request = r.toApiJson ? r : new ListBusinessReviewResponseTemplateRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewResponseTemplateService/ListBusinessReviewResponseTemplates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBusinessReviewResponseTemplateResponse.fromProto(resp)));
    }
  }
  ReviewResponseTemplateApiService.ɵfac = function ReviewResponseTemplateApiService_Factory(t) {
    return new (t || ReviewResponseTemplateApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ReviewResponseTemplateApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ReviewResponseTemplateApiService,
    factory: ReviewResponseTemplateApiService.ɵfac,
    providedIn: 'root'
  });
  return ReviewResponseTemplateApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ReviewApiService = /*#__PURE__*/(() => {
  class ReviewApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getReviews(r) {
      const request = r.toApiJson ? r : new GetReviewsRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/GetReviews", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReviewsResponse.fromProto(resp)));
    }
    updateReview(r) {
      const request = r.toApiJson ? r : new UpdateReviewRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/UpdateReview", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateReviewResponse.fromProto(resp)));
    }
    createReviewComment(r) {
      const request = r.toApiJson ? r : new CreateReviewCommentRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/CreateReviewComment", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewCommentResponse.fromProto(resp)));
    }
    updateReviewComment(r) {
      const request = r.toApiJson ? r : new UpdateReviewCommentRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/UpdateReviewComment", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateReviewCommentResponse.fromProto(resp)));
    }
    canRespondToReview(r) {
      const request = r.toApiJson ? r : new CanRespondToReviewRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/CanRespondToReview", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanRespondToReviewResponse.fromProto(resp)));
    }
    updateReviewUserDeletedInfo(r) {
      const request = r.toApiJson ? r : new UpdateReviewUserDeletedInfoRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/UpdateReviewUserDeletedInfo", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiThirdPartyReviewPublishSettings(r) {
      const request = r.toApiJson ? r : new GetMultiThirdPartyReviewPublishSettingsRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/GetMultiThirdPartyReviewPublishSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiThirdPartyReviewPublishSettingsResponse.fromProto(resp)));
    }
    suggestReviewResponse(r) {
      const request = r.toApiJson ? r : new SuggestReviewResponseRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/SuggestReviewResponse", request.toApiJson(), this.apiOptions()).pipe(map(resp => SuggestReviewResponseResponse.fromProto(resp)));
    }
    getReviewHistory(r) {
      const request = r.toApiJson ? r : new ReviewHistoryRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewService/GetReviewHistory", request.toApiJson(), this.apiOptions()).pipe(map(resp => ReviewHistoryResponse.fromProto(resp)));
    }
  }
  ReviewApiService.ɵfac = function ReviewApiService_Factory(t) {
    return new (t || ReviewApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ReviewApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ReviewApiService,
    factory: ReviewApiService.ɵfac,
    providedIn: 'root'
  });
  return ReviewApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ReviewWidgetApiService = /*#__PURE__*/(() => {
  class ReviewWidgetApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listWidgetReviews(r) {
      const request = r.toApiJson ? r : new ListWidgetReviewsRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewWidgetService/ListWidgetReviews", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListWidgetReviewsResponse.fromProto(resp)));
    }
    createReviewWidget(r) {
      const request = r.toApiJson ? r : new CreateReviewWidgetRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewWidgetService/CreateReviewWidget", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewWidgetResponse.fromProto(resp)));
    }
    updateReviewWidget(r) {
      const request = r.toApiJson ? r : new UpdateReviewWidgetRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewWidgetService/UpdateReviewWidget", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getReviewWidget(r) {
      const request = r.toApiJson ? r : new GetReviewWidgetRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewWidgetService/GetReviewWidget", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReviewWidgetResponse.fromProto(resp)));
    }
    getReviewWidgetById(r) {
      const request = r.toApiJson ? r : new GetReviewWidgetByIDRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewWidgetService/GetReviewWidgetByID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReviewWidgetByIDResponse.fromProto(resp)));
    }
    createReview(r) {
      const request = r.toApiJson ? r : new CreateReviewRequest(r);
      return this.http.post(this._host + "/reputation.v1.ReviewWidgetService/CreateReview", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewResponse.fromProto(resp)));
    }
  }
  ReviewWidgetApiService.ɵfac = function ReviewWidgetApiService_Factory(t) {
    return new (t || ReviewWidgetApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ReviewWidgetApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ReviewWidgetApiService,
    factory: ReviewWidgetApiService.ɵfac,
    providedIn: 'root'
  });
  return ReviewWidgetApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SourceApiService = /*#__PURE__*/(() => {
  class SourceApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getBusinessSources(r) {
      const request = r.toApiJson ? r : new GetBusinessSourcesRequest(r);
      return this.http.post(this._host + "/reputation.v1.SourceService/GetBusinessSources", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessSourcesResponse.fromProto(resp)));
    }
    getSourceDetails(r) {
      const request = r.toApiJson ? r : new GetSourceDetailsRequest(r);
      return this.http.post(this._host + "/reputation.v1.SourceService/GetSourceDetails", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSourceDetailsResponse.fromProto(resp)));
    }
    refreshBusinessSource(r) {
      const request = r.toApiJson ? r : new RefreshBusisinessSourceRequest(r);
      return this.http.post(this._host + "/reputation.v1.SourceService/RefreshBusinessSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SourceApiService.ɵfac = function SourceApiService_Factory(t) {
    return new (t || SourceApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SourceApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SourceApiService,
    factory: SourceApiService.ɵfac,
    providedIn: 'root'
  });
  return SourceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccountApiService, ApproveReviewResponseRequest, CanRespondToReviewRequest, CanRespondToReviewResponse, ConciergeReviewResponse, ConciergeReviewResponseApiService, CreateBrandReviewResponseTemplateRequest, CreateBusinessReviewResponseTemplateRequest, CreateDefaultReviewResponseTemplateRequest, CreateDigitalAgentReviewResponseTemplateRequest, CreatePartnerMarketReviewResponseTemplateRequest, CreateReviewCommentRequest, CreateReviewCommentResponse, CreateReviewRequest, CreateReviewRequestEmailTemplateRequest, CreateReviewRequestEmailTemplateResponse, CreateReviewResponse, CreateReviewResponseTemplateResponse, CreateReviewWidgetRequest, CreateReviewWidgetResponse, Customizations, CustomizationsOverallRatingDecimalPlaces, DeleteBrandReviewResponseTemplateRequest, DeleteBusinessReviewResponseTemplateRequest, DeleteDefaultReviewResponseTemplateRequest, DeleteDigitalAgentReviewResponseTemplateRequest, DeletePartnerMarketReviewResponseTemplateRequest, DeleteReviewRequestTemplateRequest, EmailTemplateData, FieldMask, ForceRefreshListingRequest, GetBusinessSourcesRequest, GetBusinessSourcesResponse, GetLeaveReviewURLsRequest, GetLeaveReviewURLsResponse, GetLeaveReviewURLsResponseUrlsEntry, GetLimitRequest, GetLimitResponse, GetListingsRequest, GetListingsResponse, GetMultiThirdPartyReviewPublishSettingsRequest, GetMultiThirdPartyReviewPublishSettingsResponse, GetMultiThirdPartyReviewPublishSettingsResponseThirdPartyReviewPublishSettingsEntry, GetReviewRequestEmailTemplateRequest, GetReviewRequestEmailTemplateResponse, GetReviewResponseRequest, GetReviewResponseResponse, GetReviewWidgetByIDRequest, GetReviewWidgetByIDResponse, GetReviewWidgetByIDResponseLeaveReviewUrlsEntry, GetReviewWidgetRequest, GetReviewWidgetResponse, GetReviewsRequest, GetReviewsResponse, GetSMSEnabledRequest, GetSMSEnabledResponse, GetSourceDetailsRequest, GetSourceDetailsResponse, HostService, LimitApiService, LimitType, ListBusinessReviewResponseTemplateRequest, ListBusinessReviewResponseTemplateResponse, ListReviewRequestEmailTemplatesRequest, ListReviewRequestEmailTemplatesRequestSearchOptions, ListReviewRequestEmailTemplatesRequestSortField, ListReviewRequestEmailTemplatesRequestSortOptions, ListReviewRequestEmailTemplatesResponse, ListWidgetReviewsRequest, ListWidgetReviewsRequestMinimumRating, ListWidgetReviewsResponse, Listing, ListingApiService, ListingIdentifier, ListingMatchQuality, LookupListingsRequest, LookupListingsResponse, LookupResponseForSource, MethodMetadata, NAP, PagedRequestOptions, ProvideFeedbackToReviewResponseRequest, Recommendation, RefreshBusisinessSourceRequest, Review, ReviewActionStatus, ReviewApiService, ReviewComment, ReviewDeletedStatus, ReviewHistory, ReviewHistoryRequest, ReviewHistoryResponse, ReviewIdentifier, ReviewRequestApiService, ReviewRequestTemplate, ReviewResponseTemplate, ReviewResponseTemplateApiService, ReviewStats, ReviewWidget, ReviewWidgetApiService, Reviewer, SDKMetadata, SMSState, SendReviewRequestEmailRequest, SendReviewRequestRequest, SendReviewRequestSmsRequest, SetDefaultReviewRequestTemplateRequest, SortDirection, Source, SourceApiService, SourceAttributeScope, SourceDetails, SourceHTML, SourceIcon, SourceListingInteractionHTML, SourceSubmitListing, Styling, StylingTheme, SubmitListingRequest, SubmitListingResponse, SuggestReviewResponseRequest, SuggestReviewResponseResponse, ThirdPartyPublishedStatus, ThirdPartyReviewPublishSettings, Toggles, UpdateBrandReviewResponseTemplateRequest, UpdateBusinessReviewResponseTemplateRequest, UpdateDigitalAgentReviewResponseTemplateRequest, UpdateListingRequest, UpdateReviewCommentRequest, UpdateReviewCommentResponse, UpdateReviewRequest, UpdateReviewRequestEmailTemplateRequest, UpdateReviewResponse, UpdateReviewUserDeletedInfoRequest, UpdateReviewWidgetRequest };
